/* Sofiya Mart · mobile menu drawer.
 * Markup is rendered by sections/sm-header.liquid ([data-sm-m-drawer]).
 * This file only handles open / close, focus and scroll lock.
 */
(function () {
  'use strict';

  function init() {
    var drawer = document.querySelector('[data-sm-m-drawer]');
    var openers = document.querySelectorAll('[data-sm-m-open]');
    if (!drawer || !openers.length || drawer.getAttribute('data-ready')) return;
    drawer.setAttribute('data-ready', '1');

    // Move to <body> so the sticky header's stacking context can't trap it.
    if (drawer.parentElement !== document.body) document.body.appendChild(drawer);

    var panel = drawer.querySelector('.sm-m-drawer__panel');
    var lastTrigger = null;
    var closeTimer = null;

    function setExpanded(v) {
      openers.forEach(function (b) { b.setAttribute('aria-expanded', v ? 'true' : 'false'); });
    }

    function open(e) {
      lastTrigger = (e && e.currentTarget) || openers[0];
      clearTimeout(closeTimer);
      drawer.hidden = false;
      // next frame so the slide-in transition runs
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      });
      document.body.classList.add('sm-m-lock');
      setExpanded(true);
      var closeBtn = drawer.querySelector('.sm-m-drawer__close');
      setTimeout(function () { (closeBtn || panel).focus(); }, 50);
    }

    function close() {
      if (drawer.hidden) return;
      drawer.classList.remove('is-open');
      document.body.classList.remove('sm-m-lock');
      setExpanded(false);
      closeTimer = setTimeout(function () { drawer.hidden = true; }, 300);
      if (lastTrigger) lastTrigger.focus();
    }

    openers.forEach(function (b) { b.addEventListener('click', open); });
    drawer.querySelectorAll('[data-sm-m-close]').forEach(function (el) { el.addEventListener('click', close); });

    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = panel.querySelectorAll('a[href], button, summary, select, input, [tabindex]:not([tabindex="-1"])');
      var list = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    // Close after following a same-page link (e.g. #anchors) and when growing to desktop.
    drawer.querySelectorAll('a[href]').forEach(function (a) { a.addEventListener('click', function () { setTimeout(close, 0); }); });
    var desktop = window.matchMedia('(min-width: 990px)');
    var onChange = function (ev) { if (ev.matches) close(); };
    if (desktop.addEventListener) desktop.addEventListener('change', onChange);
    else if (desktop.addListener) desktop.addListener(onChange);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: section re-render
  document.addEventListener('shopify:section:load', function () {
    var old = document.querySelectorAll('body > [data-sm-m-drawer]');
    var fresh = document.querySelector('.sm-header-wrap ~ [data-sm-m-drawer], .shopify-section [data-sm-m-drawer]');
    if (fresh) old.forEach(function (d) { if (d !== fresh) d.remove(); });
    init();
  });
})();

/* Announcement bar: "rotate" mobile layout — one message at a time on phones. */
(function () {
  'use strict';
  function initRotate() {
    document.querySelectorAll('.sm-announce--rotate:not([data-ready])').forEach(function (bar) {
      var items = bar.querySelectorAll('.sm-announce__item');
      bar.setAttribute('data-ready', '1');
      if (items.length < 2) { if (items[0]) items[0].classList.add('is-active'); return; }
      var i = 0;
      items[0].classList.add('is-active');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timer = setInterval(function () {
        if (!document.body.contains(bar)) { clearInterval(timer); return; }
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, reduce ? 6000 : 4000);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initRotate);
  else initRotate();
  document.addEventListener('shopify:section:load', initRotate);
})();

/* Collection filters: on phones/tablets start with only the first group open. */
(function () {
  'use strict';
  function collapse() {
    if (!window.matchMedia('(max-width: 989px)').matches) return;
    document.querySelectorAll('.sm-facets__scroll').forEach(function (wrap) {
      wrap.querySelectorAll('details.sm-cf__group').forEach(function (d, i) { if (i > 0) d.removeAttribute('open'); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', collapse);
  else collapse();
})();
